import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-50">
      <div className="px-4 md:px-6 py-12 md:py-16">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-20">
          <div className="lg:w-1/3">
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-fire-line text-2xl text-accent-500"></i>
              </div>
              <span className="text-lg font-semibold font-heading tracking-wider">黑料网不打烊</span>
            </Link>
            <p className="text-background-400 text-sm leading-relaxed">
              黑料网不打烊，全天候24小时不间断更新最新独家黑料内容，汇聚娱乐圈、网红、明星最劲爆料，随时随地畅享海量黑料资讯，从不停歇，永不打烊。
            </p>
          </div>

          <div className="flex-1">
            <h4 className="text-sm font-semibold mb-4 text-background-50">
              <a href="#footer-categories" className="cursor-pointer">内容分类</a>
            </h4>
            <div className="grid grid-cols-2 gap-2">
              {categories.map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className="text-background-400 hover:text-accent-400 text-sm transition-colors py-1 whitespace-nowrap cursor-pointer"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div className="flex-1">
            <h4 className="text-sm font-semibold mb-4 text-background-50">
              <a href="#footer-links" className="cursor-pointer">快速链接</a>
            </h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-background-400 hover:text-accent-400 text-sm transition-colors py-1 whitespace-nowrap cursor-pointer">首页</Link>
              <Link to="/about" className="text-background-400 hover:text-accent-400 text-sm transition-colors py-1 whitespace-nowrap cursor-pointer">关于我们</Link>
            </div>
          </div>

          <div className="flex-1">
            <h4 className="text-sm font-semibold mb-4 text-background-50">
              <a href="#footer-contact" className="cursor-pointer">联系我们</a>
            </h4>
            <div className="flex flex-col gap-2 text-sm text-background-400">
              <span>邮箱：contact@heiliao-budayang.com</span>
              <span>商务合作：business@heiliao-budayang.com</span>
              <span>内容投稿：tips@heiliao-budayang.com</span>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-background-700/40 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-background-500 text-xs">
            &copy; 2026 黑料网不打烊. All rights reserved. 本站内容仅供娱乐参考。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="w-8 h-8 flex items-center justify-center text-background-500 hover:text-accent-400 transition-colors cursor-pointer" aria-label="微信" rel="nofollow">
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a href="#" className="w-8 h-8 flex items-center justify-center text-background-500 hover:text-accent-400 transition-colors cursor-pointer" aria-label="微博" rel="nofollow">
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a href="#" className="w-8 h-8 flex items-center justify-center text-background-500 hover:text-accent-400 transition-colors cursor-pointer" aria-label="抖音" rel="nofollow">
              <i className="ri-tiktok-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}